import type { Loose } from '~/api/interface';

export const loginPopoverProps: any = () => {
  const { $t } = useNuxtApp();
  return <Loose>{
    // 登录弹窗
    login: {
      title: '',
      className: 'account-login-modal',
      width: 960,
      height: 560,
    },
    // 忘记密码
    reset: {
      title: $t('zhao-hui-mi-ma'),
      className: 'xmov-form-modal reset-account-modal',
      width: 656,
      height: 530,
    },
    // 账号切换
    select: {
      title: $t('zhu-zhang-hao-xuan-ze'),
      className: 'xmov-form-modal reset-account-modal',
      width: 450,
      height: 530,
    },
  };
};
